/**
 * Module dependencies.
 */

import { ReactElement } from 'react';
import { availableFiltersKeys } from 'src/core/content-config/model-ranges';
import BaseDisclosure from 'src/components/filters/base/base-disclosure';
import SortItem from './sort-item';
import useTranslate from 'src/hooks/use-translate';

/**
 * `Props` type.
 */

type Props = {
  filterName: string;
};

/**
 * `SortDisclosure` component.
 */

const SortDisclosure = ({ filterName }: Props): ReactElement => {
  const { translate } = useTranslate();

  return (
    <BaseDisclosure title={translate(`common:labels.${filterName}`)}>
      <SortItem
        key={'ascending'}
        label={translate('common:labels.ascending')}
        name={filterName}
        value={availableFiltersKeys[filterName]}
      />

      <SortItem
        key={'descending'}
        label={translate('common:labels.descending')}
        name={filterName}
        value={`-${availableFiltersKeys[filterName]}`}
      />
    </BaseDisclosure>
  );
};

/**
 * Export `SortDisclosure` component.
 */

export default SortDisclosure;
